import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminLeaderCategories = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADER_CATEGORIES.GET_ALL, { params });
    return response.data;
};

export const getAdminLeaderCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADER_CATEGORIES.GET_BY_ID(id));
    return response.data;
};
export const createLeaderCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.LEADER_CATEGORIES.CREATE, data);
    return response.data;
};
export const updateLeaderCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.LEADER_CATEGORIES.UPDATE(id), data);
    return response.data;
};
export const deleteLeaderCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.LEADER_CATEGORIES.DELETE(id));
    return response.data;
};

